

import format from '_shared_/plugins/format';

function setAssetMix(payloadArray, baseArray) {
  payloadArray.forEach(getObj => {
    baseArray.forEach(setObj => {
      if (getObj.SubTypeName === setObj.assetType) {
        setObj.percent = format.formatHelpers.rawPercent(getObj.Percent, 1);
      }
    });
  });
  return baseArray;
}

const baseArray = [
  {
    assetType: 'U.S. Equities',
    percent: '0.0%',
    color: 'dark-blue-fill'
  },
  {
    assetType: 'Non-U.S. Equities',
    percent: '0.0%',
    color: 'light-blue-fill'
  },
  {
    assetType: 'U.S. Bonds',
    percent: '0.0%',
    color: 'green-fill'
  },
  {
    assetType: 'Non-U.S. Bonds',
    percent: '0.0%',
    color: 'light-green-fill'
  },
  {
    assetType: 'Cash & Equivalents',
    percent: '0.0%',
    color: 'yellow-fill'
  }
];

export default {
  SET_ASSET_MIX(state, payload) {
    if (payload.assetMix.length) {
      state.assetMixData = {
        assetMix: setAssetMix(payload.assetMix, baseArray),
        assetMixChart: payload.assetMixChart,
        asOfDate: payload.assetMix[0].AsOfDate
      };
    } else {
      state.assetMixData = {};
    }
    return state.assetMixData;
  }
};
